import { Product } from "../services/models/search.models";
import {
    FacetTypes,
    Facet,
    FacetValue,
    SizeType,
    Format,
} from "../services/search.service";

/**
 * Get selected values from facet
 */
export function getSelectedValuesFromFacet(facet: Facet): Array<FacetValue> {
    if (facet.type === FacetTypes.Color || facet.type === FacetTypes.Text) {
        return (facet.values || [])
            .filter((value: FacetValue) => {
                return value.selected;
            })
            .map((value: FacetValue) => {
                return value;
            });
    }

    if (facet.type === FacetTypes.Size) {
        const values: Array<FacetValue> = [];

        (facet.sizeTypes || []).forEach((sizeType: SizeType) => {
            sizeType.formats.forEach((format: Format) => {
                format.values.forEach((value: FacetValue) => {
                    if (value.selected) {
                        values.push(value);
                    }
                });
            });
        });

        return values;
    }

    return [] as Array<FacetValue>;
}

/**
 * Get selected value ids from facet
 */
export function getSelectedValueIdsFromFacet(facet: Facet): Array<string> {
    return getSelectedValuesFromFacet(facet).map((facetValue) => facetValue.id);
}

export function getLabel(facetValue: FacetValue) {
    if (facetValue.id.indexOf("custom.matrixSize") !== -1) {
        return formatMatrixSizeLabel(facetValue.label);
    }
    if (facetValue.id.indexOf("custom.suitSize") !== -1) {
        return formatSuitSizeLabel(facetValue.label);
    }

    return facetValue.label;
}

function formatMatrixSizeLabel(label: string): string {
    let w, l;

    if (label.length === 3) {
        w = label.substring(0, 1);
        l = label.substring(1);
    } else {
        w = label.substring(0, 2);
        l = label.substring(2);
    }

    return `${w}/${l}`;
}

function formatSuitSizeLabel(label: string): string {
    return `${label.substring(0, 2)}/${label.substring(2)}`;
}

export const getCustomApptusValue = (
    customObject: Product,
    property: string,
    array = 0,
): string => {
    if (!customObject?.custom?.[property]?.[array]?.label) {
        return "";
    }

    return customObject.custom[property][0].label;
};
